@use '../../../common/styles/variables' as *;

:host {
  display: block;
  @include default-css-variables;
  width: inherit;
}

.nylas-participants-custom-availability {
  width: inherit;
  display: flex;
  flex-direction: column;
  margin: 1rem;
  border-radius: var(--nylas-border-radius-2x);
  border: 1px solid var(--nylas-base-200);
  .header {
    padding: 1rem;
    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      color: var(--nylas-base-900);
      text-align: left;
    }
    p {
      margin: 0.25rem 0 0 0;
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 20px;
      color: var(--nylas-base-600);
      text-align: left;
    }
  }
  .validation-error {
    margin: 0;
    padding: 0.75rem 1rem;
    background-color: var(--nylas-color-red-50);

    span {
      font-size: 0.875rem;
      font-weight: 500;
      line-height: 20px;
      color: var(--nylas-error);
      display: block;
    }
  }
  .content {
    .participant-container {
      padding-top: 8px;
      border-top: 1px solid var(--nylas-base-200);
      color: var(--nylas-base-900);
      background-color: var(--nylas-base-25);

      .participant-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 4px 16px 12px;
        p {
          margin: 0;
        }
        .participant-toggle {
          display: flex;
          gap: 24px;
          align-items: center;
          .chevron {
            display: flex;
            align-self: center;
            cursor: pointer;

            &:hover,
            &:active {
              color: var(--nylas-primary);
            }

            &.open {
              transform: rotate(90deg);
            }

            &.closed {
              transform: rotate(270deg);
            }

            &.disabled {
              cursor: not-allowed;
              color: var(--nylas-base-300);
              &:hover {
                color: var(--nylas-base-300);
              }
            }
          }
        }
      }
      nylas-availability-picker::part(nap) {
        margin: 0;
        border: none;
      }
      nylas-specific-time-availability-picker::part(nstap) {
        margin: 0;
        border: none;
      }
      .participant-only-specific-time-container {
        padding: 8px 16px;
        border-top: 1px solid var(--nylas-base-200);
        background-color: var(--nylas-base-50);

        .participant-only-specific-time-checkbox {
          label {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            font-weight: 400;
            color: var(--nylas-base-900);
            cursor: pointer;

            input[type='checkbox'] {
              width: 16px;
              height: 16px;
              cursor: pointer;
              accent-color: var(--nylas-primary);
            }

            span {
              flex: 1;
            }

            tooltip-component {
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }
    .participant-tabs {
      justify-content: space-between;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
      padding: 8px 16px;
      border-top: 1px solid var(--nylas-base-200);

      &.single-tab {
        grid-template-columns: 1fr;
      }
    }
    .participant-tab {
      cursor: pointer;
      padding: 8px 16px;
      border-radius: var(--nylas-border-radius-2x);
      background-color: var(--nylas-base-100);
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: var(--nylas-base-600);
      &.active {
        background-color: var(--nylas-primary);
        color: var(--nylas-base-100);
      }
    }
  }
}
